import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { usePlayerProgress } from '../contexts/PlayerContext';
import { getTierColor } from '../constants/levelUnlocks';
import './XPBar.css';

const XPBar = () => {
  const { t } = useTranslation();
  const { level, currentXp, xpForNextLevel } = usePlayerProgress();

  const progress = xpForNextLevel > 0 ? Math.min(currentXp / xpForNextLevel, 1) : 0;
  const percent = Math.round(progress * 100);
  const tierColor = getTierColor(level);

  return (
    <div className="xp-bar-container">
      <div className="xp-bar-level-badge" style={{ background: tierColor }}>
        {t('xp_level', { level })}
      </div>
      <div className="xp-bar-track">
        <div
          className="xp-bar-fill"
          style={{
            width: `${percent}%`,
            background: `linear-gradient(90deg, ${tierColor}, ${tierColor}cc)`,
          }}
        />
      </div>
      <span className="xp-bar-info">
        <span className="xp-percent">{percent}%</span>{' '}
        {currentXp.toLocaleString()} / {xpForNextLevel.toLocaleString()}
      </span>
    </div>
  );
};

export default memo(XPBar);
